var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "solutions-menu" }, [
    _c(
      "div",
      { staticClass: "extended-block" },
      [
        _c("h6", [_vm._v("Solutions")]),
        _vm._v(" "),
        _c("menu-item", {
          attrs: {
            path: "/about/solutions#digital-engagement",
            text: "Digital engagement",
            caption:
              "Leverage our data, network and partnerships across Africa to digitally connect with corporate partners",
          },
          on: {
            click: function ($event) {
              return _vm.handleItemClick("/about/solutions#digital-engagement")
            },
          },
        }),
        _vm._v(" "),
        _c("menu-item", {
          attrs: {
            path: "/about/solutions#custom-research",
            text: "Custom research",
            caption:
              "Call on our pan-African corporate database and in-country analyst network to conduct market analysis",
          },
          on: {
            click: function ($event) {
              return _vm.handleItemClick("/about/solutions#custom-research")
            },
          },
        }),
        _vm._v(" "),
        _c("menu-item", {
          attrs: {
            path: "/about/solutions#compliance-support",
            text: "Compliance support",
            caption:
              "Benefit from our access to corporate registries to gather company records at industry-leading turnaround times",
          },
          on: {
            click: function ($event) {
              return _vm.handleItemClick("/about/solutions#compliance-support")
            },
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "extended-block" },
      [
        _c("h6", [_vm._v("Publications")]),
        _vm._v(" "),
        _c("menu-item", {
          attrs: {
            path: "/insights/market-insights",
            text: "Market Insights",
            caption:
              "Access Asoko's proprietary insights on Africa's private sector",
          },
          on: {
            click: function ($event) {
              return _vm.handleItemClick("/insights/market-insights")
            },
          },
        }),
        _vm._v(" "),
        _c("menu-item", {
          attrs: {
            path: "/insights/developments",
            text: "Corporate news",
            caption:
              "View the latest news and updates on Asoko’s partnerships, events and opportunities",
          },
          on: {
            click: function ($event) {
              return _vm.handleItemClick("/insights/developments")
            },
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _vm.showProjectsLink
      ? _c(
          "div",
          { staticClass: "extended-block user-block" },
          [
            _c("h6", [_vm._v("You and Asoko")]),
            _vm._v(" "),
            _c("user-menu-item", {
              attrs: {
                path: "/projects",
                text: "My projects",
                caption:
                  "Start and manage your custom research projects with Asoko's in-country analyst teams",
              },
              on: {
                click: function ($event) {
                  return _vm.handleItemClick("/projects")
                },
              },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }